import { recordedEventsDefinition } from './recordedEventsDefinition';
// Explicit user-level allowlist: never serialize nested registrations or credentials.
const counts = ['app_loads', 'games_created', 'games_joined', 'games_confirmed',
  'follows_made', 'followers_gained', 'club_memberships_count',
  'club_invites_sent', 'club_invites_accepted', 'recorded_events_last_7_days', 'recorded_events_last_30_days'];
const categories = ['active_strict_eligible', 'active_missing_ownership', 'active_otherwise_ineligible', 'inactive_or_unset'];
export const csvColumns = ['name', 'username', 'signup_at', 'latest_recorded_engagement_event_at', 'activity_range_start',
  'activity_range_end', ...counts.map(key => ['app_loads', 'games_created', 'games_joined', 'games_confirmed', 'follows_made', 'followers_gained'].includes(key) ? key + '_selected_range' : key), 'relationship_activity_definition', 'following_count_current', 'follower_count_current', 'dob_present', 'address_present', 'profile_presence_definition', ...categories,
  'registration_observed_at', 'native_usage_evidence', 'native_usage_observed_at',
  'native_app_version_build', 'permission_evidence', 'permission_observed_at', 'recorded_events_definition'];

export function csvCell(value) {
  let text = String(value ?? '');
  // CSV quoting alone does not prevent spreadsheet formulas. Neutralize text cells,
  // including formulas hidden behind whitespace and control characters.
  if (/^[\s\u0000-\u001f]*[=+\-@]/u.test(text) || /^[\t\r\n]/.test(text)) text = "'" + text;
  return '"' + text.replace(/"/g, '""') + '"';
}

export function userActivityCsv(rows, {start, end, registrationObservedAt}) {
  const values = rows.map(row => [row.display_name || '', row.username || '', row.created_at || '',
    row.last_active_at || '', start, end, ...counts.map(key => row[key] ?? 0),
    'Currently retained accepted relationship records created in selected range; not historical removed follows',
    row.following_count ?? 'Unavailable', row.follower_count ?? 'Unavailable',
    ...[row.dob_present, row.address_present].map(value => typeof value === 'boolean' ? (value ? 'Yes' : 'No') : 'Unavailable'),
    'Presence checks only; not validation or participation eligibility',
    ...categories.map(key => row.push_registration_report?.counts?.[key] ?? 'Unavailable'),
    registrationObservedAt || 'Unavailable',
    'Not collected', '', 'Not collected', 'Not collected', '', recordedEventsDefinition]);
  return '\ufeff' + [csvColumns, ...values].map(record => record.map(csvCell).join(',')).join('\r\n') + '\r\n';
}

export function downloadUserActivityCsv(rows, metadata) {
  const url = URL.createObjectURL(new Blob([userActivityCsv(rows, metadata)], {type: 'text/csv;charset=utf-8'}));
  const link = document.createElement('a');
  link.href = url;
  link.download = `openruns-user-activity-${metadata.start}-${metadata.end}.csv`;
  document.body.appendChild(link);
  try { link.click(); } finally { link.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000); }
}
